import { FC } from 'react'
import { Alert, Typography, SxProps } from '@mui/material'
import { useIntl } from 'react-intl'

interface OperationsFrozenMessageProps {
  variant?: 'inline' | 'banner'
  sx?: SxProps
}

const OperationsFrozenMessage: FC<OperationsFrozenMessageProps> = ({ variant = 'inline', sx }) => {
  const { formatMessage } = useIntl()

  const message = formatMessage({
    id: 'general.operationsFrozenInfo',
    defaultMessage: 'Twoja umowa została zakończona. Kontakt: ...'
  })

  if (variant === 'banner') {
    return (
      <Alert severity='info' sx={{ borderRadius: 0, ...sx }}>
        {message}
      </Alert>
    )
  }

  return (
    <Typography
      sx={{ fontWeight: 400, fontSize: '18px', textAlign: 'center', marginTop: '20px', ...sx }}>
      {message}
    </Typography>
  )
}

export default OperationsFrozenMessage
